import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import moment from 'moment-timezone';

export const FLUID_SCHEDULE_SETTINGS_KEY = 'fluid-schedule-settings';

const emptySettings = {
    date: null,
    filters: null,
    search: null,
    searchBy: null,
    controls: null,
};

// eslint-disable-next-line import/prefer-default-export
export const useFluidScheduleSettings = create(
    persist(
        (set) => ({
            userId: null,
            ...emptySettings,
            saveSettings: (userId, settings) => set((state) => (state.userId === userId ? settings : { ...emptySettings, ...settings, userId })),
        }),
        {
            name: FLUID_SCHEDULE_SETTINGS_KEY,
            storage: createJSONStorage(() => localStorage, {
                reviver: (_key, value) => {
                    if (value?.type === 'moment') {
                        return moment(value.value);
                    }
                    return value;
                },
                replacer(key, value) {
                    const raw = this[key];
                    if (moment.isMoment(raw)) {
                        return { type: 'moment', value: raw.toISOString() };
                    }
                    return value;
                },
            }),
            partialize: ({ saveSettings, ...settings }) => settings,
        }
    )
);
